<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.update_user_permission' | translate}} {{user.fullName}}
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<!-- them ten nguoi dung -->
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onclickButtonUpdate(user.fullName)">
  <mat-dialog-content>
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3 mb-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.user_permission' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="col-sm-6">
            <small>{{'form.fullname' | translate}}</small>
            <p class="dotted">{{user.fullName}}</p>
          </div>

          <div class="col-sm-6">
            <small>{{'form.user_type' | translate}}</small>
            <p class="dotted">{{user.userType == 1 ? 'Admin' : 'User'}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <label class="col-form-label font-weight-bold">{{'form.all_auth' | translate}}</label>
            <mat-form-field class="mat-full-width">
              <input cdkFocusInitial #focusInput="matInput" type="text" autocomplete="off" matInput
                name="groupPermissions" [(ngModel)]="filterWords" (ngModelChange)="onFilterFeatures()"
                [placeholder]="'placeholder.search_user_group' | translate"
                (focusout)="filterWords = filterWords == undefined ? '' : (filterWords + '').trim()" />
              <button mat-button *ngIf="filterWords" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="filterWords=''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <label class="col-form-label font-weight-bold text-left">{{'form.select_auth' | translate}}</label>
            <mat-form-field class="mat-full-width">
              <input type="text" autocomplete="off" matInput name="groupPermissions" [(ngModel)]="filterWordsSelected"
                (focusout)="filterWordsSelected=filterWordsSelected.trim()" (ngModelChange)="onFilterFeaturesSelected()"
                [placeholder]="'placeholder.search_user_group' | translate" />
              <button mat-button *ngIf="filterWordsSelected" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="filterWordsSelected=''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-md-5 pr-075">
            <div class="card vt-list-role" *ngIf="user.userType != 1">
              <div class="card-body">
                <div tabindex="0" id="myLeftTab{{i}}"
                  (keyup.arrowdown)="this.commonService.downArrow(i,'myLeftTab', this.dataList)"
                  (keyup.arrowup)="this.commonService.upArrow(i,'myLeftTab', this.dataList)"
                  (keyup.enter)="this.commonService.moveEvent(i,'myLeftTab', 'moveLeft')"
                  *ngFor="let data of dataList; let i = index" (click)='getIndex(data)' class="list mt-1 p-1"
                  [ngClass]="{'list': this.leftList.indexOf(data) >= 0}">{{data.name}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-2 text-center pr-075">
            <div>
              <div id="moveLeft" class="mt-2 stroked-button">
                <div class="angle-button {{this.leftList.length == 0 ? 'disable' : ''}}" (click)="moveClick()">
                  <i class="fa fa-angle-right fa-lg" aria-hidden="true"></i>
                </div>
              </div>
              <div class="mt-2 stroked-button">
                <div class="angle-button {{this.dataList.length == 0 ? 'disable' : ''}}" (click)="moveAllClick()">
                  <i class="fa fa-angle-double-right fa-lg" aria-hidden="true"></i>
                </div>
              </div>
              <div class="mt-2 stroked-button">
                <div id="moveRight" class="angle-button {{this.rightList.length == 0 ? 'disable' : ''}}" (click)="returnClick()">
                  <i class="fa fa-angle-left fa-lg" aria-hidden="true"></i>
                </div>
              </div>
              <div class="mt-2 stroked-button">
                <div class="angle-button {{this.selectedList.length == 0 ? 'disable' : ''}}" (click)="returnAllClick()">
                  <i class="fa fa-angle-double-left fa-lg" aria-hidden="true"></i>
                </div>
              </div>
              <!-- <div class="mt-2">
                <button id="moveLeft" mat-stroked-button color="primary" type="button" (click)='moveClick()'
                  [disabled]="this.leftList.length == 0">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
              <div class="mt-2">
                <button mat-stroked-button color="primary" type="button" (click)='moveAllClick()'
                  [disabled]="this.dataList.length == 0">
                  <mat-icon aria-hidden="true">last_page</mat-icon>
                </button>
              </div>
              <div class="mt-2">
                <button id="moveRight" mat-stroked-button color="primary" type="button" (click)='returnClick()'
                  [disabled]="this.rightList.length == 0">
                  <mat-icon>chevron_left</mat-icon>
                </button>
              </div>
              <div class="mt-2 mb-2">
                <button mat-stroked-button color="primary" type="button" (click)='returnAllClick()'
                  [disabled]="this.selectedList.length == 0">
                  <mat-icon aria-hidden="true">first_page</mat-icon>
                </button>
              </div> -->
            </div>
          </div>
          <div class="col-md-5 pr-075">
            <div class="card vt-list-role" *ngIf="user.userType != 1">
              <div class="card-body">
                <div tabindex="0" id="myRightTab{{i}}"
                  (keyup.arrowdown)="this.commonService.downArrow(i,'myRightTab', this.selectedList)"
                  (keyup.arrowup)="this.commonService.upArrow(i,'myRightTab', this.selectedList)"
                  (keyup.enter)="this.commonService.moveEvent(i,'myRightTab','moveRight')"
                  *ngFor="let data of selectedList; let i = index" (click)='getReturnIndex(data)' class="list mt-1 p-1"
                  [ngClass]="{'list': this.rightList.indexOf(data) >= 0}">{{data.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="!isChangePermission()" type="submit" color="primary">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.save' | translate}}
    </button>
  </mat-dialog-actions>
</form>
